module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-900.woff?76ab0ada7a6529d158bd98a08121068b";